import React, { useEffect, useState } from "react";

const API_BASE = "https://hostel-laundry-api.onrender.com";

export default function BagTag() {
  const [student, setStudent] = useState(null);
  const [error, setError] = useState("");

  const params = new URLSearchParams(window.location.search);
  const usn = params.get("usn");

  useEffect(() => {
    if (!usn) {
      setError("USN missing in link");
      return;
    }

    fetch(`${API_BASE}/api/admin/students/${usn}`)
      .then((res) => res.json())
      .then((data) => setStudent(data))
      .catch(() => setError("Failed to load student info"));
  }, [usn]);

  if (error) return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Inter', sans-serif",
      background: "#ffffff",
    }}>
      <p style={{ color: "#525252", fontSize: "14px" }}>{error}</p>
    </div>
  );

  if (!student) return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Inter', sans-serif",
      background: "#ffffff",
    }}>
      <p style={{ color: "#a3a3a3", fontSize: "14px" }}>Loading...</p>
    </div>
  );

  return (
    <div
      style={{
        fontFamily: "'Inter', sans-serif",
        display: "flex",
        justifyContent: "center",
        paddingTop: "40px",
        background: "#ffffff",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          width: "330px",
          background: "white",
          borderRadius: "16px",
          padding: "24px 24px 28px 24px",
          border: "1px solid #e5e5e5",
          textAlign: "center",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h1
            style={{
              fontSize: "22px",
              fontWeight: "700",
              color: "#0a0a0a",
              margin: 0,
              letterSpacing: "1.5px",
            }}
          >
            LAUNDROID
          </h1>

          <p
            style={{
              fontSize: "12px",
              marginTop: "4px",
              marginBottom: "12px",
              color: "#737373",
              letterSpacing: "0.5px",
            }}
          >
            Hostel Laundry Management
          </p>

          <div
            style={{
              width: "60%",
              height: "1px",
              background: "#e5e5e5",
            }}
          ></div>
        </div>

        {/* STUDENT DETAILS */}
        <div style={{ marginTop: "16px", marginBottom: "20px" }}>
          <p style={{ fontSize: "17px", fontWeight: "700", margin: "4px 0", color: "#0a0a0a" }}>
            {student.name}
          </p>

          <p style={{ fontSize: "14px", margin: "4px 0", fontWeight: "500", color: "#525252" }}>
            USN: <span style={{ fontWeight: "700", color: "#0a0a0a" }}>{student.usn}</span>
          </p>

          <p style={{ fontSize: "14px", margin: "4px 0", fontWeight: "500", color: "#525252" }}>
            Room: <span style={{ fontWeight: "700", color: "#0a0a0a" }}>{student.room}</span>
          </p>
        </div>

        {/* QR CODE */}
        <div
          style={{
            padding: "16px",
            border: "1px solid #e5e5e5",
            borderRadius: "12px",
            background: "white",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={student.qr_code}
            alt="QR Code"
            style={{
              width: "170px",
              height: "170px",
              objectFit: "contain",
            }}
          />
        </div>

        <p
          style={{
            marginTop: "12px",
            fontSize: "11px",
            color: "#a3a3a3",
            letterSpacing: "0.4px",
          }}
        >
          Scan to Login • SJEC Hostel Laundry
        </p>

        {/* DIVIDER */}
        <div
          style={{
            width: "60%",
            height: "1px",
            background: "#e5e5e5",
            margin: "16px auto 14px auto",
          }}
        ></div>

        {/* PRINT BUTTON */}
        <button
          style={{
            padding: "12px 16px",
            background: "#171717",
            color: "white",
            border: "none",
            borderRadius: "10px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            width: "100%",
            fontFamily: "'Inter', sans-serif",
            transition: "background 0.2s",
          }}
          onMouseOver={(e) => e.target.style.background = "#262626"}
          onMouseOut={(e) => e.target.style.background = "#171717"}
          onClick={() => window.print()}
        >
          Print Tag
        </button>
      </div>
    </div>
  );
}
